/**
 * Format a date string as "Jan 15, 2000". Returns '-' for empty/null/undefined.
 */
export function formatDate(d) {
    if (!d) return '-';
    const date = new Date(d);
    if (isNaN(date.getTime())) return d;
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

/**
 * Convert any date string to YYYY-MM-DD for <input type="date">.
 * Returns '' for empty/null/unparseable values.
 */
export function toInputDate(d) {
    if (!d) return '';
    // Already YYYY-MM-DD
    if (/^\d{4}-\d{2}-\d{2}$/.test(d)) return d;
    const date = new Date(d);
    if (isNaN(date.getTime())) return '';
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}

/**
 * Format a phone number. 10-digit numbers display as (XXX) XXX-XXXX.
 * Returns '-' for empty/null/undefined. Otherwise returns as-is.
 */
export function formatPhone(p) {
    if (!p) return '-';
    const digits = p.replace(/\D/g, '');
    if (digits.length === 10) {
        return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    if (digits.length === 11 && digits[0] === '1') {
        return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
    }
    return p;
}

/**
 * Return true if the birthdate indicates the person is under 18.
 */
export function isMinor(birthdate) {
    if (!birthdate) return false;
    const bd = new Date(birthdate + 'T00:00:00');
    if (isNaN(bd.getTime())) return false;
    const today = new Date();
    let age = today.getFullYear() - bd.getFullYear();
    const mDiff = today.getMonth() - bd.getMonth();
    if (mDiff < 0 || (mDiff === 0 && today.getDate() < bd.getDate())) age--;
    return age < 18;
}

/**
 * Return a relative timestamp string like "just now", "3m ago", "2h ago", "5d ago", "1mo ago", "1y ago".
 */
export function timeAgo(dateStr) {
    if (!dateStr) return '';
    const now = Date.now();
    const then = new Date(dateStr).getTime();
    if (isNaN(then)) return '';
    const seconds = Math.floor((now - then) / 1000);
    if (seconds < 60) return 'just now';
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes}m ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    if (days < 30) return `${days}d ago`;
    const months = Math.floor(days / 30);
    if (months < 12) return `${months}mo ago`;
    const years = Math.floor(months / 12);
    return `${years}y ago`;
}
